import { render, staticRenderFns } from "./SimpleKeyboard.vue?vue&type=template&id=54b1fe0a&"
import script from "./SimpleKeyboard.vue?vue&type=script&lang=js&"
export * from "./SimpleKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./SimpleKeyboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports